<template>
    <div id="onboarding">
        <div class="screen screen1" v-if="form.step == 1">
            <img src="@/assets/home-top-image.png" alt="" />

            <h1>Welcome!</h1>

            <p>
                We just need a few details and we can get your account set up and connected to your
                Pro.
            </p>

            <p class="green">
                All the benefits and features Lesson Pro has to offer are completely free. In app
                purchases from your golf professional are available.
            </p>

            <button @click.prevent="form.step = 2" class="button">Sign me up</button>

            <div class="login-form-nav-links mt40">
                <router-link to="/login">Already have an account?</router-link>
            </div>

            <ul class="puts">
                <li><img src="@/assets/put-active.svg" /></li>
            </ul>
        </div>

        <div class="screen screen2" v-if="form.step == 2">
            <span class="info dark">Please enter your details:</span>

            <form action="" class="form2">
                <div class="formGroup" :class="{ invalid: form.errors.has('email') }">
                    <label>Enter your email</label>
                    <input type="email" v-model="form.email" />
                    <has-error :form="form" field="email"></has-error>
                </div>

                <div class="formGroup" :class="{ invalid: form.errors.has('password') }">
                    <label>Choose a password</label>
                    <input type="password" v-model="form.password" />
                    <has-error :form="form" field="password"></has-error>
                </div>

                <div
                    class="formGroup"
                    :class="{
                        invalid: form.errors.has('password_confirmation'),
                    }"
                >
                    <label>Confirm password</label>
                    <input type="password" v-model="form.password_confirmation" />
                    <has-error :form="form" field="password_confirmation"></has-error>
                </div>

                <div class="formGroup" :class="{ invalid: form.errors.has('token') }">
                    <label>Enter 6 digit validation code</label>
                    <input type="text" v-model="form.token" maxlength="6" />
                    <has-error :form="form" field="token"></has-error>
                </div>

                <button
                    class="button"
                    @click.prevent="addDetails"
                    :disabled="form2.busy"
                    type="button"
                    name="button"
                >
                    {{ form2.busy ? "Please wait..." : "Next step" }}
                </button>
            </form>

            <div class="login-form-nav-links mt40">
                <a href="" @click.prevent="form.step = 1">Back</a>
            </div>

            <ul class="puts">
                <li>
                    <img src="@/assets/put-active.svg" />
                </li>

                <li>
                    <img src="@/assets/put-inactive.svg" />
                </li>

                <li>
                    <img src="@/assets/put-inactive.svg" />
                </li>

                <li>
                    <img src="@/assets/put-inactive.svg" />
                </li>
            </ul>
        </div>

        <div class="screen screen2" v-else-if="form.step == 3">
            <span class="info dark">Please enter your address details:</span>
            <form class="form2" @submit.prevent="addDetails">
                <div class="formGroup" :class="{ invalid: form.errors.has('address_line1') }">
                    <label>Address line 1</label>
                    <input maxlength="250" type="text" v-model="form.address_line1" />
                </div>
                <div class="formGroup" :class="{ invalid: form.errors.has('address_line2') }">
                    <label>Address line 2</label>
                    <input maxlength="250" type="text" v-model="form.address_line2" />
                </div>
                <div class="formGroup" :class="{ invalid: form.errors.has('address_city') }">
                    <label>Town / City</label>
                    <input maxlength="250" type="text" v-model="form.address_city" />
                </div>
                <div class="formGroup" :class="{ invalid: form.errors.has('address_county') }">
                    <label>State/County</label>
                    <input maxlength="250" type="text" v-model="form.address_county" required />
                </div>
                <div
                    class="formGroup mb40"
                    :class="{ invalid: form.errors.has('address_postcode') }"
                >
                    <label>Postcode</label>
                    <input maxlength="250" type="text" v-model="form.address_postcode" />
                </div>

                <div class="formGroup nb">
                    <button class="button" type="submit">
                        {{ form.busy ? "Please wait..." : "Next" }}
                    </button>
                </div>
            </form>

            <div class="login-form-nav-links mt40">
                <a href="" @click.prevent="form.step = 2">Back</a>
            </div>

            <ul class="puts">
                <li><img src="@/assets/put-active.svg" /></li>
                <li><img src="@/assets/put-active.svg" /></li>
                <li><img src="@/assets/put-inactive.svg" /></li>
                <li><img src="@/assets/put-inactive.svg" /></li>
            </ul>
        </div>

        <div class="screen screen2" v-else-if="form.step == 4">
            <span class="info dark">Please confirm your personal details:</span>
            <form class="form2" @submit.prevent>
                <div class="formGroup" :class="{ invalid: form.errors.has('first_name') }">
                    <label>First name</label>
                    <input maxlength="250" type="text" v-model="form.first_name" />
                </div>
                <div class="formGroup" :class="{ invalid: form.errors.has('last_name') }">
                    <label>Last name</label>
                    <input maxlength="250" type="text" v-model="form.last_name" />
                </div>

                <div class="formGroup" :class="{ invalid: form.errors.has('gender') }">
                    <label>Gender</label>
                    <select v-model="form.gender">
                        <option value=""></option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                </div>

                <div class="formGroup" :class="{ invalid: form.errors.has('phone') }">
                    <label>Telephone number</label>
                    <phone-number-field
                        v-model="form.phone"
                        class="dark-mode"
                        required
                    ></phone-number-field>
                </div>

                <div class="formGroup mb40" :class="{ invalid: form.errors.has('tos') }">
                    <label class="checkbox">
                        <input type="checkbox" v-model="form.tos" />I agree to Lesson Pro
                        <a
                            target="_blank"
                            @click.prevent="openExternalTab('https://lessonpro.co.uk/terms')"
                            href="https://lessonpro.co.uk/terms/"
                            >terms</a
                        >
                        <span class="checkmark"></span>
                    </label>
                </div>

                <div class="formGroup nb">
                    <button @click.prevent="addDetails" class="button" type="submit">
                        {{ form.busy ? "Please wait..." : "Next" }}
                    </button>
                </div>
            </form>

            <div class="login-form-nav-links mt40">
                <a href="" @click.prevent="form.step = 3">Back</a>
            </div>

            <ul class="puts">
                <li><img src="@/assets/put-active.svg" /></li>
                <li><img src="@/assets/put-active.svg" /></li>
                <li><img src="@/assets/put-active.svg" /></li>
                <li><img src="@/assets/put-inactive.svg" /></li>
            </ul>
        </div>

        <div class="screen screen4" v-show="form.step == 5 || form.step == 6">
            <span class="info dark" style="margin-bottom: 10px"
                >To make purchases from your Golf Professional you will need to enter valid credit
                or debit card details:</span
            >

            <span
                class="info dark"
                style="margin-top: 0px; background: #15f29f; color: #497060; font-size: 16px"
                >YOUR CARD WILL NOT BE CHARGED AT ANYTIME WITHOUT YOUR CONSENT AT THE TIME OF
                PURCHASES.</span
            >
            <form class="form2">
                <div class="formGroup">
                    <label>Name as it appears on card</label>
                    <input type="text" v-model="form2.name" />
                </div>
                <div class="formGroup">
                    <div class="card" ref="card"></div>
                </div>

                <div class="formGroup nb" v-if="form2.name">
                    <button @click.prevent="addDetails" class="button" type="submit">
                        {{ busy ? "Please wait..." : "Confirm" }}
                    </button>
                </div>
            </form>

            <div class="login-form-nav-links mt40">
                <a href="" @click.prevent="form.step = 4">Back</a>
            </div>

            <ul class="puts">
                <li><img src="@/assets/put-active.svg" /></li>
                <li><img src="@/assets/put-active.svg" /></li>
                <li><img src="@/assets/put-active.svg" /></li>
                <li><img src="@/assets/put-active.svg" /></li>
            </ul>
        </div>
    </div>
</template>

<script>
import { Form, HasError } from "vform";
import Cookie from "js-cookie";
import * as Sentry from "@sentry/vue";

export default {
    components: { HasError },
    created() {
        var style = {
            base: {
                iconColor: "#FFFFFF",
                color: "#FFFFFF",
                fontSize: "16px",
                fontFamily: "canada-type-gibson",
                "::placeholder": {
                    color: "#CFD7E0",
                },
            },
        };

        this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
        var elements = this.stripe.elements({
            fonts: [
                {
                    cssSrc: "https://use.typekit.net/efu4trn.css",
                },
            ],
        });
        this.card = elements.create("card", { style: style });

        this.$nextTick(() => {
            console.log(this.$refs.card);
            this.card.mount(this.$refs.card);
            //this.form.fill(this.user);
        });

        this.getIntent();
    },
    data() {
        return {
            busy: false,
            oWebViewInterface: window.nsWebViewInterface,
            form: new Form({
                step: 1,
                email: "",
                password: "",
                password_confirmation: "",
                token: "",
                address_line1: "",
                address_line2: "",
                address_city: "",
                address_county: "",
                address_postcode: "",
                first_name: "",
                last_name: "",
                gender: "",
                phone: "",
                stripe_customer: "",
                tos: false,
            }),
            form2: new Form({
                client_secret: "",
                name: "",
                payment_method: "",
            }),
        };
    },
    methods: {
        openExternalTab(url) {
            this.oWebViewInterface.emit("openExternalTab", url);
        },
        getIntent() {
            this.form.get("/stripe/intent").then((response) => {
                this.form2.client_secret = response.data.client_secret;
            });
        },
        addDetails() {
            this.form.post("/player/onboard").then((response) => {
                if (this.form.step == 4) {
                    this.createStripeAccount();
                }

                if (this.form.step == 5) {
                    Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, response.data.api_token);
                    this.$store.dispatch("updateUser", response.data);
                    window.axios.defaults.headers.common["Authorization"] =
                        "Bearer " + response.data.api_token;
                    this.oWebViewInterface.emit("apiTokenRecieved", response.data.api_token);
                    this.addCardDetails();
                    this.form.step = 6;
                }

                if (this.form.step == 6) {
                    this.addCardDetails();
                }

                if (this.form.step == 4) {
                    this.form.step = 5;
                }
                if (this.form.step == 3) {
                    this.form.step = 4;
                }
                if (this.form.step == 2) {
                    this.form.step = 3;
                }
            });
        },
        createStripeAccount: function () {
            this.form.post("/stripe/add-customer").then((response) => {
                this.form2.client_secret = response.data.client_secret;
                this.form.stripe_customer = response.data.customer;
            });
        },
        addCardDetails() {
            this.busy = true;

            this.stripe
                .confirmCardSetup(this.form2.client_secret, {
                    payment_method: {
                        card: this.card,
                        billing_details: {
                            name: this.form.name,
                        },
                    },
                })
                .then((result) => {
                    this.busy = false;
                    if (result.error) {
                        this.$notify({
                            type: "error",
                            text: result.error.message,
                        });
                    } else {
                        this.completeSetup(result.setupIntent.payment_method);
                    }
                });
        },
        completeSetup($method) {
            try {
                localStorage.setItem("first_visit", true);
            } catch (e) {
                Sentry.captureException(e);
                return false;
            }
            this.form2.payment_method = $method;
            this.$notify("You're all setup. Welcome to Lesson Pro!");
            this.form2.post("/stripe/add-card-details").then((response) => {
                this.$store.state.user.stripe_card = response.data.stripe_card;
            });
            this.$router.push("/");
        },
    },
};
</script>

<style lang="scss" scoped>
#onboarding {
    background: #257961;
    min-height: 100vh;
    .info {
        background: #555855;
        color: white;
        margin-bottom: 56px;
        text-align: center;
        line-height: 24px;
        margin-top: 40px;
    }
    .form2 {
        .formGroup {
            margin-bottom: 20px;
            border-bottom: 2px solid #3c6a5c;
            &.nb {
                border: 0px;
            }
            &.mb40 {
                margin-bottom: 40px;
            }

            input[type="text"],
            input[type="email"],
            input[type="tel"],
            input[type="password"],
            select {
                color: white;
                font-size: 20px;
                padding-top: 1px;
            }

            input[type="checkbox"]:after:checked {
                content: "";
                width: 10px;
                height: 10px;
                background: red;
            }
            select {
                width: 100%;
                padding: 20px 0px;
                padding-top: 1px;
                border: 0px;
                background: none;
                margin-left: -3px;
                font-family: canada-type-gibson, sans-serif;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                color: white;
                &:focus {
                    outline: 0;
                }
            }
        }
        label {
            color: #15f29f;

            &.checkbox {
                padding-bottom: 20px;
                display: block;
                color: white;
                position: relative;
                input[type="checkbox"] {
                    width: 28px;
                    height: 28px;
                    background: white;
                    appearance: none;
                    border-radius: 8px;
                    transform: translateY(4px);
                    margin: 0px;

                    margin-right: 10px;
                }

                input[type="checkbox"]:checked ~ .checkmark {
                    width: 12px;
                    height: 12px;
                    background: #267962;
                    position: absolute;
                    border-radius: 4px;
                    top: 12px;
                    left: 8px;
                    display: block;
                }

                a {
                    float: right;
                    color: #1dd992;
                    margin-top: 14px;
                }
            }
        }
    }
    .screen {
        padding: 20px;

        &.screen1 {
            text-align: center;
            padding-top: 70px;
            img {
                border-radius: 24px;
                margin-bottom: 58px;
            }
        }

        h1 {
            font-size: 32px;
            color: white;
            margin-bottom: 30px;
        }
        p {
            margin-bottom: 50px;
            line-height: 1.5;
            color: white;
            &.green {
                color: #1fcd8b;
                margin-bottom: 35px;
            }
        }
        .button {
            max-width: 245px;
            margin: 0 auto;
        }
    }
    .card {
        margin-bottom: 20px;
    }
    .mt40 {
        margin-top: 40px;
    }
    .puts {
        height: 46px;
        width: 132px;
        margin: 0 auto;
        margin-top: 20px;
        li {
            display: inline-block;
            margin-right: 10px;
            &:last-of-type {
                margin-right: 0px;
            }
        }

        @media (min-height: 770px) {
            position: fixed;
            bottom: 60px;
            left: 50%;
            margin-left: -66px;
        }
    }
}
</style>
